import React from "react";
import {Col, Row, Radio, Card, Button} from "antd";
import JSONInput from "react-json-editor-ajrm";
import {FhirResource, fhirVersions} from 'fhir-react';
import locale from 'react-json-editor-ajrm/locale/en';
import {copyToClipboard, flattenJson} from "../../utils/util"
import MappingQA from "./mappingQA";
import {FLATTENED_VIEW, JSON_VIEW, MAPPING_VIEW, NARRATIVE_VIEW, QA_VIEW_SELECT, TREE_VIEW, REFERENCE_VIEW} from "../../consts";
import JSONTree from "react-json-tree";
import {CopyOutlined, FolderOutlined} from "@ant-design/icons";
import {isString} from "lodash";
import ReferenceQA from './referenceQA';

class QAViewWrapper extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedView: !!props.defaultView ? props.defaultView : MAPPING_VIEW,
            currentResource: this.props.resource[0],
            currentPage: 0,
            key: 0
        }
    }

    onChange = (checked) => {
        this.setState({selectedView: checked.target.value})
        if (checked.target.value !== REFERENCE_VIEW) {
          localStorage.setItem(QA_VIEW_SELECT, checked.target.value);
        }
    }

    getResourceFormat = () => {
        if (this.state.currentResource) {
            switch (this.state.selectedView) {
                case FLATTENED_VIEW:
                    return flattenJson(this.state.currentResource.resource);
                case JSON_VIEW:
                    return this.state.currentResource.resource;
                case TREE_VIEW:
                    return <JSONTree data={this.state.currentResource.resource}
                                     valueRenderer={(key) =><strong className="tree-hover">{key}</strong>}
                                     labelRenderer={([key]) => <span className="tree-hover">
                                             <FolderOutlined style={{color: '#8a8a8a'}}/> {key}
                                         </span>
                                     }
                                     hideRoot={true}
                                     shouldExpandNode={() => true}
                                     getItemString={() => {}}
                                     theme={{
                                         base00: 'none',
                                         base0B: '#000000',
                                         base0D: '#000000',
                                     }}
                                     invertTheme={false}  />
                case REFERENCE_VIEW:
                    return (
                        <ReferenceQA
                        key={this.state.key}
                        mappings={this.props.mappings}
                        sampleData={this.props.sampleData}
                        resourcetype={this.props.resourcetype}
                        namespace={this.props.namespace}
                        version={this.props.version}
                        resource={this.state.currentResource.resource}
                        />
                    );
                case MAPPING_VIEW:
                    return <MappingQA key={this.state.key}
                                      mappings={this.props.mappings}
                                      sampleData={this.props.sampleData}
                                      version={this.props.version}
                                      resource={this.state.currentResource.resource}/>
                default:
                    return <FhirResource
                        fhirResource={this.state.currentResource.resource}
                        fhirVersion={fhirVersions.R4}
                        withCarinBBProfile={true}
                    />
            }
        } else {
            return 'Not Implemented Yet'
        }
    }

    changePage() {
        this.setState({currentResource: this.props.resource[this.state.currentPage]}, () => {
            this.getResourceFormat()
            this.forceUpdate()
        })
    }

    changeResource(next, e) {
        e.stopPropagation()
        let page = this.state.currentPage;
        if (next) {
            ++page;
        } else {
            --page;
        }
        this.setState({currentPage: page}, () => {
            this.setState({key: Math.random()});
            this.changePage();
        })
    }

    outOfRange = (button) => {
        let page = this.state.currentPage;
        if (++page >= this.props.resource.length && button === "next") {
            return true;
        } else if (this.state.currentPage === 0 && button === "prev") {
            return true;
        } else {
            return false;
        }
    }

    render() {
        let title = !!this.props.title ? this.props.title : ""
        return (
            <Card title={title}>
                <Row align="middle" justify="start" style={{marginBottom: 5}}>
                    {
                        !!this.props.type &&
                        <Col>
                            <h3>{this.props.type} &nbsp;</h3>
                        </Col>
                    }

                    <Col style={{position: 'absolute', right: '0', marginRight: '25px'}}>
                        {
                            !!this.props.showPagination &&
                            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'right'}}>
                                <Button
                                    style={{float: 'right'}}
                                    disabled={this.outOfRange("prev")}
                                    onClick={(e) => this.changeResource(false, e)}>
                                    Previous
                                </Button>
                                <Button style={{outline: 'none', float: 'right', pointerEvents: 'none'}}>
                                    Showing {this.state.currentPage + 1} of {this.props.resource.length} Results
                                </Button>
                                <Button
                                    style={{float: 'right'}}
                                    disabled={this.outOfRange("next")}
                                    onClick={(e) => this.changeResource(true, e)}>
                                    Next
                                </Button>
                            </div>
                        }

                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div style={{display: 'inline-flex', justifyContent: 'center', alignItems: 'center', marginBottom: 5}}>
                            <Radio.Group onChange={this.onChange}
                                         value={this.state.selectedView}
                                         initialValue={this.state.selectedView}
                                         size="small">
                                <Radio.Button value={MAPPING_VIEW}>Mapping</Radio.Button>
                                <Radio.Button value={TREE_VIEW}>Tree</Radio.Button>
                                <Radio.Button value={JSON_VIEW}>JSON (Raw)</Radio.Button>
                                <Radio.Button value={FLATTENED_VIEW}>JSON (Flat)</Radio.Button>
                                <Radio.Button value={NARRATIVE_VIEW}>Narrative</Radio.Button>
                                {this.props.reference === true && (
                                    <Radio.Button value={REFERENCE_VIEW}>Reference</Radio.Button>
                                )}
                            </Radio.Group>
                            { (this.state.selectedView === JSON_VIEW || this.state.selectedView === FLATTENED_VIEW) &&
                                <span className="click-active" style={{marginLeft: 20, cursor: 'pointer'}} onClick={() => copyToClipboard(JSON.stringify(this.getResourceFormat(),null, 2))}>
                                    <CopyOutlined/>
                                </span>
                            }
                        </div>
                    </Col>
                </Row>
                <Row style={{marginBottom: 5}}>
                    <Col span={24}>
                        <Card>
                            {
                                (this.state.selectedView === JSON_VIEW || this.state.selectedView === FLATTENED_VIEW) &&
                                <JSONInput
                                    placeholder={isString(this.getResourceFormat()) ? {} : this.getResourceFormat()}
                                    confirmGood={false}
                                    viewOnly={true}
                                    width={"100%"}
                                    locale={locale}
                                    theme={"light_mitsuketa_tribute"}
                                    key={this.state.key}
                                />
                            }
                            {
                                (this.state.selectedView === NARRATIVE_VIEW ||
                                    this.state.selectedView === MAPPING_VIEW ||
                                    this.state.selectedView === TREE_VIEW ||
                                    this.state.selectedView === REFERENCE_VIEW) &&
                                this.getResourceFormat()
                            }
                        </Card>
                    </Col>
                </Row>
            </Card>
        )
    }
}

export default QAViewWrapper